// Create a tool pill element
export function createToolPill(toolName) {
  const pill = document.createElement("div")
  pill.classList.add("flex", "items-center", "gap-1.5", "text-xs", "text-content", "py-1")
  pill.dataset.toolName = toolName
  pill.dataset.toolPending = "true"

  const spinner = document.createElement("span")
  spinner.classList.add("tool-spinner")
  spinner.textContent = "○"
  pill.appendChild(spinner)

  const label = document.createElement("span")
  label.textContent = toolName || ""
  pill.appendChild(label)

  return pill
}

// Mark a tool pill as complete
export function completeToolPill(container, toolName) {
  const pill = [...container.children].find(
    el => el.dataset.toolName === toolName && el.dataset.toolPending === "true"
  )
  if (!pill) return
  delete pill.dataset.toolPending
  const spinner = pill.querySelector(".tool-spinner")
  if (spinner) {
    spinner.textContent = "✓"
    spinner.classList.remove("tool-spinner")
    spinner.classList.add("text-accent-green")
  }
}

// Update the tools summary count
export function updateToolsSummary(details, container) {
  if (!details || !container) return
  const count = container.children.length
  const summary = details.querySelector("summary")
  if (summary) {
    summary.textContent = `${count} tool ${count === 1 ? "call" : "calls"}`
  }
}
